import React, { useEffect, useState } from "react";

import { useHistory } from "react-router";

const ProductBox = ({
  product,
  comparehandler,
  setProductModal,
  navigateProductDetails,
  width,
  imageHeight,
}) => {
  const history = useHistory();
  const addToCompare = () => {
    comparehandler(product);
  };

  const setProduct = () => {
    setProductModal(product);
  };

  const fullView = (e) => {
    e.preventDefault();
    history.push({
      pathname: "/productDetails",

      state: { products: product },
    });
  };

  const height = imageHeight ? imageHeight : 210;
  return (
    <>
      <div class="col-md-12" style={{ height: 600 }}>
        <figure
          class="figure product-box wow fadeIn animated"
          data-wow-delay="0ms"
          style={{ margin: "2em 40px !important" }}
        >
          <div class="product-box-img" style={{ height: height }}>
            <a>
              <img src={product.image} class="prod-img" alt="Product Img" />
            </a>
          </div>
          <div class="quick-view-btn">
            <div class="compare-btn">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                data-toggle="modal"
                data-target={`.bd-example-modal-lg-${product._id}`}
                onClick={() => setProduct()}
              >
                <i class="fa fa-eye" aria-hidden="true"></i> Quick view
              </button>
            </div>
          </div>
          <figcaption class="figure-caption text-center">
            <div class="price-start">
              <p class="font-weight-700">{product.name}</p>
              <p class="font-weight-700">{product.company_name}</p>
              <p class="font-weight-500">{` ${product.price}`}</p>
            </div>
            <div class="compare-btn fullview-btn" onClick={(e) => fullView(e)}>
              <a class="btn btn-primary btn-sm" href="#">
                <i class="fa fa-expand" aria-hidden="true"></i> Full view
              </a>
            </div>
            <div class="compare-btn" onClick={() => addToCompare()}>
              <a class="btn btn-primary btn-sm" href="#">
                <i class="fa fa-exchange" aria-hidden="true"></i> Add to compare
              </a>
            </div>
          </figcaption>
        </figure>
      </div>
    </>
  );
};

export default ProductBox;
